
export const SHOP_OWNER_EXPIRE_SESSION = 'SHOP_OWNER_EXPIRE_SESSION';
export const SHOP_OWNER_EXPIRE_SESSION_LOADING = 'SHOP_OWNER_EXPIRE_SESSION_LOADING';
export const SHOP_OWNER_EXPIRE_SESSION_SUCCESS = 'SHOP_OWNER_EXPIRE_SESSION_SUCCESS';
export const SHOP_OWNER_EXPIRE_SESSION_FAILURE = 'SHOP_OWNER_EXPIRE_SESSION_FAILURE';

export const SHOP_LOGIN_DISABLE_REVERT = 'SHOP_LOGIN_DISABLE_REVERT';
export const SHOP_LOGIN_DISABLE_REVERT_LOADING = 'SHOP_LOGIN_DISABLE_REVERT_LOADING';
export const SHOP_LOGIN_DISABLE_REVERT_SUCCESS = 'SHOP_LOGIN_DISABLE_REVERT_SUCCESS';
export const SHOP_LOGIN_DISABLE_REVERT_FAILURE = 'SHOP_LOGIN_DISABLE_REVERT_FAILURE';

export const SHOP_DISABLE_REQUEST_OTP = 'SHOP_DISABLE_REQUEST_OTP';
export const SHOP_DISABLE_REQUEST_OTP_LOADING = 'SHOP_DISABLE_REQUEST_OTP_LOADING';
export const SHOP_DISABLE_REQUEST_OTP_SUCCESS = 'SHOP_DISABLE_REQUEST_OTP_SUCCESS';
export const SHOP_DISABLE_REQUEST_OTP_FAILURE = 'SHOP_DISABLE_REQUEST_OTP_FAILURE';

export const SHOP_DISABLE_REQUEST_CONFIRM = 'SHOP_DISABLE_REQUEST_CONFIRM';
export const SHOP_DISABLE_REQUEST_CONFIRM_LOADING = 'SHOP_DISABLE_REQUEST_CONFIRM_LOADING';
export const SHOP_DISABLE_REQUEST_CONFIRM_SUCCESS = 'SHOP_DISABLE_REQUEST_CONFIRM_SUCCESS';
export const SHOP_DISABLE_REQUEST_CONFIRM_FAILURE = 'SHOP_DISABLE_REQUEST_CONFIRM_FAILURE';

export const SHOP_UNBLOCK_FORCE_REQUEST = 'SHOP_UNBLOCK_FORCE_REQUEST';
export const SHOP_UNBLOCK_FORCE_REQUEST_LOADING = 'SHOP_UNBLOCK_FORCE_REQUEST_LOADING';
export const SHOP_UNBLOCK_FORCE_REQUEST_SUCCESS = 'SHOP_UNBLOCK_FORCE_REQUEST_SUCCESS';
export const SHOP_UNBLOCK_FORCE_REQUEST_FAILURE = 'SHOP_UNBLOCK_FORCE_REQUEST_FAILURE';

export const SHOP_UNBLOCK_INIT_REQUEST = 'SHOP_UNBLOCK_INIT_REQUEST';
export const SHOP_UNBLOCK_INIT_REQUEST_LOADING = 'SHOP_UNBLOCK_INIT_REQUEST_LOADING';
export const SHOP_UNBLOCK_INIT_REQUEST_SUCCESS = 'SHOP_UNBLOCK_INIT_REQUEST_SUCCESS';
export const SHOP_UNBLOCK_INIT_REQUEST_FAILURE = 'SHOP_UNBLOCK_INIT_REQUEST_FAILURE';

export const SHOP_UNBLOCK_CONFIRM_REQUEST = 'SHOP_UNBLOCK_CONFIRM_REQUEST';
export const SHOP_UNBLOCK_CONFIRM_REQUEST_LOADING = 'SHOP_UNBLOCK_CONFIRM_REQUEST_LOADING';
export const SHOP_UNBLOCK_CONFIRM_REQUEST_SUCCESS = 'SHOP_UNBLOCK_CONFIRM_REQUEST_SUCCESS';
export const SHOP_UNBLOCK_CONFIRM_REQUEST_FAILURE = 'SHOP_UNBLOCK_CONFIRM_REQUEST_FAILURE';

export const shopOwnerExpireSessionBackendPath = '/backend/shop/owner/clear/session/';
export const shopLoginDisableRevertBackendPath = '/backend/auth/disabled_account/revert/';
export const shopDisableInitBackendPath = '/backend/shop/disable/init/';
export const shopDisableConfirmBackendPath = '/backend/shop/disable/confirm/';
export const shopUnblockForceBackendPath = '/backend/shop/unblock/force/';
export const shopUnblockInitBackendPath = '/backend/shop/unblock/init/';
export const shopUnblockConfirmBackendPath = '/backend/shop/unblock/confirm/';

export const shopOwnerExpireSession = (data, cancelPrevious = true) => ({
  type: SHOP_OWNER_EXPIRE_SESSION,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: shopOwnerExpireSessionBackendPath, cancelPrevious }
});

export const shopLoginDisableRevert = (data, cancelPrevious = true, callback) => ({
  type: SHOP_LOGIN_DISABLE_REVERT,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: shopLoginDisableRevertBackendPath, cancelPrevious },
  callback: callback
});


export const shopDisableRequestOtpVerify = (data, cancelPrevious = true, callback) => ({
  type: SHOP_DISABLE_REQUEST_OTP,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: shopDisableInitBackendPath, cancelPrevious },
  callback: callback,
});


export const shopDisableRequestConfirm = (data, cancelPrevious = true) => ({
  type: SHOP_DISABLE_REQUEST_CONFIRM,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: shopDisableConfirmBackendPath, cancelPrevious }
});

export const shopUnblockForceRequest = (data, cancelPrevious = true) => ({
    type: SHOP_UNBLOCK_FORCE_REQUEST,
    payload: { data },
    meta: { httpMethod: 'POST', apiPath: shopUnblockForceBackendPath, cancelPrevious }
});

export const shopUnblockInitRequest = (data, cancelPrevious = true, callback) => ({
    type: SHOP_UNBLOCK_INIT_REQUEST,
    payload: { data },
    meta: { httpMethod: 'POST', apiPath: shopUnblockInitBackendPath, cancelPrevious },
    callback: callback,
});

export const shopUnblockConfirmRequest = (data, cancelPrevious = true) => ({
    type: SHOP_UNBLOCK_CONFIRM_REQUEST,
    payload: { data },
    meta: { httpMethod: 'POST', apiPath: shopUnblockConfirmBackendPath, cancelPrevious }
});




// WEBPACK FOOTER //
// ./src/actions/shop/index.js